export const isEmpty = v => v === null || v === '';
export const isMinimumLength = (v, min) => v && v.length >= min;
export const isValidUsername = v => //https://stackoverflow.com/questions/12018245/regular-expression-to-validate-username/12019115#12019115
/^(?=[a-zA-Z0-9._]{3,20}$)(?!.*[_.]{2})[^_.].*[^_.]$/i.test(v || '');
export const isBlocklist = v => {
  if (!v) return false;
  const blocklist = ['connect', 'connectdotcom', 'edit', 'hubspot', 'directory', 'member', 'username', 'about', 'add', 'admin', 'administrator'];
  return blocklist.includes(v.toLowerCase());
};